module.exports = __webpack_public_path__ + "img/371DF49C-B214-48AD-886A-0AD8BEA02135_1_201_a-min.0bc64038.jpeg";